import clsx from "clsx";
import "./PlatformIssueCard.scss";
import ResetIcon from "../../../../../components/icons/ResetIcon";

type Variant = "error" | "warning";

type Props = {
  variant: Variant;
  heading: string;
  title?: string;
  message?: string;
  onRetry?: () => void;
};

const PlatformIssueCard = ({
  variant,
  heading,
  title,
  message,
  onRetry,
}: Props) => {
  const leftIconSrc =
    variant === "error" ? "/images/Error.svg" : "/images/warning-icon.svg";

  const leftIconAlt = variant === "error" ? "Error" : "Warning";

  return (
    <div
      className={clsx("platform-issue-card", `platform-issue-card--${variant}`)}
    >
      <div className="platform-issue-card__left">
        <img
          className="platform-issue-card__icon"
          src={leftIconSrc}
          alt={leftIconAlt}
        />
      </div>

      <div className="platform-issue-card__content">
        <div className="platform-issue-card__heading">{heading}</div>

        {!!title && <div className="platform-issue-card__title">{title}</div>}
        {!!message && (
          <div className="platform-issue-card__message">{message}</div>
        )}

        {variant === "error" && onRetry && (
          <div className="platform-issue-card__actions">
            <button
              type="button"
              className="platform-issue-card__retry"
              onClick={onRetry}
            >
              <ResetIcon />
              <span>Retry now</span>
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default PlatformIssueCard;
